import { createSelector } from "reselect";
var defaultOrganization = {};
var getOrganization = function(state) {
    return state.organization || defaultOrganization;
};
var getOrganizationId = createSelector(getOrganization, function(org) {
    return org && org.id || "";
});
export var OrganizationSelectors = {
    getOrganization: getOrganization,
    getOrganizationId: getOrganizationId
};

//# sourceMappingURL=OrganizationSelectors.js.map